module.exports = __webpack_public_path__ + "img/users-gear-solid.3144dca7.svg";